module.exports = __webpack_public_path__ + "static/img/bf312f53cf635ae480f0e07fcecd860.b1ab3229.png";